<template>
  <button-dropdown v-if="infos.options.length > 1" :infos="infos" :defaultOption="listInitial" @change="changeList"/>
</template>

<script>
  import cookie from 'vue-cookie'
  import ButtonDropdown from '@/components/template/ButtonDropdown'

  export default {
    data: () => ({
      infos: {
        label: 'displayList',
        identifier: 'type-list',
        icon: 'icon-insert-template',
        options: [
          {
            label: 'details',
            value: 'displayDetails'
          },
          {
            label: 'list',
            value: 'displayList'
          }
        ]
      },
      listInitial: 'displayDetails'
    }),
    props: {
      typesListAvailable: {
        type: Array,
        default: () => ([
          'displayDetails',
          'displayList'
        ])
      }
    },
    created () {
      this.infos.options = this.infos.options.filter(option => this.typesListAvailable.indexOf(option.value) !== -1)

      if (cookie.get('listInitial')) {
        this.changeList(cookie.get('listInitial'))
      }
    },
    methods: {
      changeList (value) {
        this.listInitial = value
        cookie.set('listInitial', value)
        this.$emit('change', this.listInitial)
      }
    },
    components: {
      ButtonDropdown
    }
  }
</script>



// WEBPACK FOOTER //
// TypeList.vue?60fe0696